var re = Object.defineProperty, ie = Object.defineProperties;
var ne = Object.getOwnPropertyDescriptors;
var B = Object.getOwnPropertySymbols;
var se = Object.prototype.hasOwnProperty, ue = Object.prototype.propertyIsEnumerable;
var F = (d, l, r) => l in d ? re(d, l, { enumerable: !0, configurable: !0, writable: !0, value: r }) : d[l] = r, P = (d, l) => {
  for (var r in l || (l = {}))
    se.call(l, r) && F(d, r, l[r]);
  if (B)
    for (var r of B(l))
      ue.call(l, r) && F(d, r, l[r]);
  return d;
}, q = (d, l) => ie(d, ne(l));
var C = (d, l, r) => new Promise((h, y) => {
  var v = (m) => {
    try {
      u(r.next(m));
    } catch (g) {
      y(g);
    }
  }, k = (m) => {
    try {
      u(r.throw(m));
    } catch (g) {
      y(g);
    }
  }, u = (m) => m.done ? h(m.value) : Promise.resolve(m.value).then(v, k);
  u((r = r.apply(d, l)).next());
});
import "../../node_modules/.pnpm/vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { postSpecialApplyCreate as de } from "../../request/designordercenter/productionOrder/specialApply/create/post.js";
import { postGetAiModifyList as fe } from "../../request/designordercenter/productionOrder/operation/getAiModifyList/post.js";
import { getDict as M, selfAxios as j } from "@oppein/op-utils";
import pe from "../../com-components/file-upload/fileUpload.vue.js";
import { defineComponent as me, useTemplateRef as E, provide as R, onMounted as ce, openBlock as ye, createElementBlock as ve, createElementVNode as A, createVNode as i, withCtx as p, createTextVNode as $, Fragment as ge } from "../../node_modules/.pnpm/@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { useMessage as Ce } from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/message/src/use-message.js";
import { useDialog as be } from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/dialog/src/composables.js";
import { ref as n, unref as s } from "../../node_modules/.pnpm/@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import he from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/spin/src/Spin.js";
import xe from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/card/src/Card.js";
import Te from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/form/src/Form.js";
import b from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/form/src/FormItem.js";
import { toDisplayString as we } from "../../node_modules/.pnpm/@vue_shared@3.5.18/node_modules/@vue/shared/dist/shared.esm-bundler.js";
import _e from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/select/src/Select.js";
import z from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/input/src/Input.js";
import G from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/button/src/Button.js";
import De from "../../node_modules/.pnpm/naive-ui@2.42.0_vue@3.5.18/node_modules/naive-ui/es/modal/src/Modal.js";
const Re = { style: { width: "100%", display: "flex", "justify-content": "center" } }, He = /* @__PURE__ */ me({
  __name: "aiModifyDialog.ce",
  emits: ["submit"],
  setup(d, { expose: l, emit: r }) {
    const h = E("aiModifyDialogContainer"), y = E("formRef"), v = Ce(), k = be(), u = n(!1), m = n(""), g = n(""), O = n(""), x = n("");
    R("oauth2AccessToken", m), R("appCode", g), R("subAppCode", O), R("env", x);
    const c = n(!1), S = n(""), T = n([]), f = n({
      modifyType: "",
      modifyContent: "",
      modifyReason: ""
    }), H = {
      modifyType: {
        required: !0,
        message: "请选择修改类型",
        trigger: ["blur", "change"]
      },
      modifyContent: {
        required: !0,
        message: "请输入修改内容",
        trigger: ["blur", "input"]
      },
      modifyReason: {
        required: !0,
        message: "请输入修改原因",
        trigger: ["blur", "input"]
      }
    }, N = n([]), J = n([]), K = n([]), Q = () => C(this, null, function* () {
      const [t, e] = yield Promise.all([M("ROOT_brand"), M("ROOT_category")]);
      J.value = t, K.value = e;
    }), W = (t) => C(this, null, function* () {
      try {
        const e = yield M("ROOT_MTDS_order_modify_type");
        console.log("modifyTypeDict---", e), N.value = e.filter((a) => a.extendAttr2 === t).map((a) => ({
          label: a.label,
          value: a.remarks
        }));
      } catch (e) {
        console.error("获取修改类型字典失败:", e), N.value = [];
      }
    }), X = () => C(this, null, function* () {
      var t;
      try {
        yield (t = y.value) == null ? void 0 : t.validate(), c.value = !0;
        const e = yield de(q(P({}, _.value), {
          specialApplyType: "modify_bpm_process",
          modifyType: f.value.modifyType,
          content: f.value.modifyContent,
          reason: f.value.modifyReason,
          attachInfoList: T.value.map((a) => ({
            attachUrl: a.url,
            attachName: a.name,
            attachTime: a.lastModified
          })),
          isAutomatic: 1
        }));
        e && e.status ? (v.success("订单修改申请已提交，请等待审批"), u.value = !1, w(), c.value = !1) : (c.value = !1, u.value = !1);
      } catch (e) {
        c.value = !1, e != null && e.errors || (console.error("请求失败:", e), v.error("请完善必填信息"));
      }
    }), w = () => {
      var t;
      f.value = {
        modifyType: "",
        modifyContent: "",
        modifyReason: ""
      }, T.value = [], (t = y.value) == null || t.restoreValidation();
    }, _ = n({
      orderId: ""
    });
    ce(() => C(this, null, function* () {
      yield Q();
    }));
    const Y = () => C(this, null, function* () {
      var t, e, a, U, L, V;
      c.value = !0;
      try {
        const o = yield fe({ orderId: _.value.orderId });
        if (c.value = !1, o && o.status && ((t = o == null ? void 0 : o.data) != null && t.Success)) {
          if ((e = o == null ? void 0 : o.data) != null && e.CostDetails && ((a = o == null ? void 0 : o.data) == null ? void 0 : a.CostDetails.length) === 0)
            u.value = !0;
          else if ((U = o == null ? void 0 : o.data) != null && U.CostDetails && ((L = o == null ? void 0 : o.data) == null ? void 0 : L.CostDetails.length) > 0) {
            const ae = (V = o == null ? void 0 : o.data) == null ? void 0 : V.CostDetails.map((le) => le.Category).join("、");
            k.warning({
              title: "提示",
              content: `当前订单${ae}二级品类已生产，计划会产生部分费用，最终金额以实际结算为准，是否确认发起修改单审批流程`,
              positiveText: "确认发起",
              negativeText: "取消",
              onPositiveClick: () => {
                u.value = !0;
              },
              onNegativeClick: () => {
                v.info("已取消");
              }
            });
          }
        }
      } catch (o) {
        c.value = !1, console.error("获取修改列表失败:", o), v.error("系统异常");
      }
    }), Z = () => {
      g.value = "MTDS", O.value = "MTDSPC001", m.value = j.defaults.headers.common["Oauth2-AccessToken"] || "";
      const t = j.defaults.baseURL;
      t === "https://apigatewayuat.oppein.com/" ? x.value = "uat" : t === "https://apigatewayver.oppein.com/" ? x.value = "ver" : t === "https://apigateway.oppein.com/" && (x.value = "pro");
    };
    n([]);
    const I = n(!1);
    let D = null;
    function ee(t) {
      Z(), _.value.orderId = t.orderId || "", S.value = t.productionOrderContractNo || "", I.value = t.needCheck || !1;
      const e = t.category || "";
      e && W(e), w(), I.value ? Y() : u.value = !0;
    }
    const te = () => {
      u.value = !1, w(), D = null, _.value = {
        orderId: ""
      };
    }, oe = () => {
      u.value = !1, w(), D && (D([]), D = null);
    };
    return l({ open: ee }), (t, e) => (ye(), ve(ge, null, [
      A("div", {
        ref_key: "aiModifyDialogContainer",
        ref: h
      }, null, 512),
      i(s(De), {
        bordered: "",
        show: u.value,
        "onUpdate:show": e[4] || (e[4] = (a) => u.value = a),
        "mask-closable": !1,
        "z-index": 9999,
        to: h.value || "body"
      }, {
        default: p(() => [
          i(s(he), { show: c.value }, {
            default: p(() => [
              i(s(xe), {
                style: { width: "800px" },
                title: "修改订单",
                bordered: !1,
                role: "dialog",
                closable: "",
                onClose: te
              }, {
                default: p(() => [
                  i(s(Te), {
                    ref_key: "formRef",
                    ref: y,
                    model: f.value,
                    rules: H,
                    "label-placement": "left",
                    "label-width": "130px"
                  }, {
                    default: p(() => [
                      i(s(b), { label: "订单合同自编号：" }, {
                        default: p(() => [
                          A("span", null, we(S.value || ""), 1)
                        ]),
                        _: 1
                      }),
                      i(s(b), {
                        label: "修改类型：",
                        path: "modifyType"
                      }, {
                        default: p(() => [
                          i(s(_e), {
                            value: f.value.modifyType,
                            "onUpdate:value": e[0] || (e[0] = (a) => f.value.modifyType = a),
                            options: N.value,
                            placeholder: "请选择修改类型",
                            style: { width: "300px" }
                          }, null, 8, ["value", "options"])
                        ]),
                        _: 1
                      }),
                      i(s(b), {
                        label: "修改内容：",
                        path: "modifyContent"
                      }, {
                        default: p(() => [
                          i(s(z), {
                            type: "textarea",
                            value: f.value.modifyContent,
                            "onUpdate:value": e[1] || (e[1] = (a) => f.value.modifyContent = a),
                            placeholder: "请输入修改内容，最多500字",
                            maxlength: 500,
                            "show-count": "",
                            style: { width: "600px", "min-height": "100px" }
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      i(s(b), {
                        label: "修改原因：",
                        path: "modifyReason"
                      }, {
                        default: p(() => [
                          i(s(z), {
                            type: "textarea",
                            value: f.value.modifyReason,
                            "onUpdate:value": e[2] || (e[2] = (a) => f.value.modifyReason = a),
                            placeholder: "请输入修改原因，最多500字",
                            maxlength: 500,
                            "show-count": "",
                            style: { width: "600px", "min-height": "100px" }
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      }),
                      i(s(b), { label: "附件：" }, {
                        default: p(() => [
                          i(pe, {
                            value: T.value,
                            "onUpdate:value": e[3] || (e[3] = (a) => T.value = a),
                            "business-type": "handbill",
                            maxLength: 10,
                            disabled: !1,
                            isDelete: !0
                          }, null, 8, ["value"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["model"]),
                  A("div", Re, [
                    i(s(G), {
                      onClick: oe,
                      style: { "margin-top": "22px", "border-radius": "5px" }
                    }, {
                      default: p(() => e[5] || (e[5] = [
                        $("关闭", -1)
                      ])),
                      _: 1,
                      __: [5]
                    }),
                    i(s(G), {
                      onClick: X,
                      style: { "margin-left": "30px", "margin-top": "22px", "background-color": "#3370ff !important", "border-color": "#3370ff !important", "--n-border": "1px solid #3370ff", "--n-button-color": "#fff !important", "border-radius": "5px" },
                      type: "primary"
                    }, {
                      default: p(() => e[6] || (e[6] = [
                        $("确认", -1)
                      ])),
                      _: 1,
                      __: [6]
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["show"])
        ]),
        _: 1
      }, 8, ["show", "to"])
    ], 64));
  }
});
export {
  He as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/ai-modify-dialog/aiModifyDialog.ce.vue2.js
// module id = 1154
// module chunks = 41